/*! angular-timepicker 1.0.8 | (c) 2014, Geta AS | MIT (http://www.opensource.org/licenses/MIT) */ ! function (a) {
  "use strict";
  a.module("dnTimepicker", ["ui.bootstrap.position", "dateParser"]).factory("dnTimepickerHelpers", function () {
    return {
      stringToMinutes: function (a) {
        if (!a) return null;
        var b = a.match(/(\d+)(h?)/);
        return b[1] ? b[1] * (b[2] ? 60 : 1) : null
      },
      buildOptionList: function (b, c, d) {
        for (var e = [], f = a.copy(b); c >= f;) e.push(new Date(f)), f.setMinutes(f.getMinutes() + d);
        return e
      },
      getClosestIndex: function (b, c) {
        if (!a.isDate(b)) return -1;
        for (var d = null, e = -1, f = 60 * b.getHours() + b.getMinutes(), g = 0; g < c.length; g++) {
          var h = c[g],
            i = 60 * h.getHours() + h.getMinutes();
          (null === d || Math.abs(i - f) < Math.abs(d - f)) && (d = i, e = g)
        }
        return e
      }
    }
  }).directive("dnTimepicker", ["$compile", "$parse", "$uibPosition", "$document", "dateFilter", "$dateParser", "dnTimepickerHelpers", "$log",
    function (b, c, d, e, f, g, h, i) {
      return {
        restrict: "A",
        require: "ngModel",
        scope: {
          ngModel: "="
        },
        link: function (c, j, k, l) {
          function m(b) {
            return o || (o = a.isDate(c.ngModel) ? c.ngModel : new Date), o.setHours(b.getHours()), o.setMinutes(b.getMinutes()), o.setSeconds(b.getSeconds()), n(o), o
          }

          function n(b) {
            a.isDate(b) || (b = g(c.ngModel, c.timepicker.timeFormat), isNaN(b) && i.warn("Failed to parse model.")), o = b
          }
          var o = null,
            p = [],
            q = !0;
          c.timepicker = {
            element: null,
            timeFormat: "h:mm a",
            minTime: g("0:00", "H:mm"),
            maxTime: g("23:59", "H:mm"),
            step: 15,
            isOpen: !1,
            activeIdx: -1,
            optionList: function () {
              return q && (p = h.buildOptionList(c.timepicker.minTime, c.timepicker.maxTime, c.timepicker.step), q = !1), p
            }
          }, k.$observe("dnTimepicker", function (a) {
            a && (c.timepicker.timeFormat = a), l.$render()
          }), k.$observe("minTime", function (a) {
            a && (c.timepicker.minTime = g(a, c.timepicker.timeFormat), q = !0)
          }), k.$observe("maxTime", function (a) {
            a && (c.timepicker.maxTime = g(a, c.timepicker.timeFormat), q = !0)
          }), k.$observe("step", function (a) {
            if (a) {
              var b = h.stringToMinutes(a);
              b && (c.timepicker.step = b), q = !0
            }
          }), c.$watch("ngModel", function (a) {
            n(a), l.$render()
          }), l.$render = function () {
            j.val(a.isDate(o) ? f(o, c.timepicker.timeFormat) : l.$viewValue ? l.$viewValue : "")
          }, l.$parsers.unshift(function (b) {
            var d = a.isDate(b) ? b : g(b, c.timepicker.timeFormat);
            return isNaN(d) ? void l.$setValidity("time", !1) : (l.$setValidity("time", !0), m(d))
          }), c.select = function (b) {
            a.isDate(b) && (l.$setViewValue(m(b)), l.$render())
          }, c.isActive = function (a) {
            return a === c.timepicker.activeIdx
          }, c.setActive = function (a) {
            c.timepicker.activeIdx = a
          }, c.scrollToSelected = function () {
            if (c.timepicker.element && c.timepicker.activeIdx > -1) {
              var a = c.timepicker.element[0].querySelector(".active");
              a.parentNode.scrollTop = a.offsetTop - 50
            }
          }, c.openPopup = function () {
            c.position = d.position(j), c.position.top = c.position.top + j.prop("offsetHeight"), c.timepicker.isOpen = !0, c.timepicker.activeIdx = h.getClosestIndex(c.ngModel, c.timepicker.optionList()), c.$digest(), c.scrollToSelected()
          }, c.closePopup = function () {
            c.timepicker.isOpen && (c.timepicker.isOpen = !1, c.$apply(), j[0].blur())
          }, j.after(b(a.element("<div dn-timepicker-popup></div>"))(c)), j.bind("focus", function () {
            c.openPopup()
          }).bind("keypress keyup", function (a) {
            38 === a.which && c.timepicker.activeIdx > 0 ? (c.timepicker.activeIdx--, c.scrollToSelected()) : 40 === a.which && c.timepicker.activeIdx < c.timepicker.optionList().length - 1 ? (c.timepicker.activeIdx++, c.scrollToSelected()) : 13 === a.which && c.timepicker.activeIdx > -1 && (c.select(c.timepicker.optionList()[c.timepicker.activeIdx]), c.closePopup()), c.$digest()
          }), e.bind("click", function (a) {
            c.timepicker.isOpen && a.target !== j[0] && c.closePopup()
          }), n(c.ngModel)
        }
      }
    }
  ]).directive("dnTimepickerPopup", function () {
    return {
      restrict: "A",
      replace: !0,
      transclude: !1,
      template: '<ul class="dn-timepicker-popup dropdown-menu" ng-style="{display: timepicker.isOpen && \'block\' || \'none\', top: position.top+\'px\', left: position.left+\'px\'}"><li ng-repeat="time in timepicker.optionList()" ng-class="{active: isActive($index) }" ng-mouseenter="setActive($index)"><a ng-click="select(time)">{{time | date:timepicker.timeFormat}}</a></li></ul>',
      link: function (a, b) {
        a.timepicker.element = b, b.find("a").bind("click", function (a) {
          a.preventDefault()
        })
      }
    }
  })
}(angular);
//# sourceMappingURL=angular-timepicker.min.js.map
